import { Button, FormFieldTypeFG, FormGenerator } from '@hwm/ui-lib';
import { t, Trans } from '@lingui/macro';
import { FormikProps, Formik } from 'formik';
import { isEmpty } from 'lodash';
import React, { useRef } from 'react';
import { useCallback } from 'react';
import { useSelectedSitesDataSource } from '../SiteList/sitesDataSource';
import { saveSelectedSitesListValidationSchemaFn } from './SaveSelectedSitesList.utils';

export const SaveSelectedSitesList: React.FC = () => {
  const formikRef = useRef<FormikProps<{ name: string }>>(null);

  const { handleCreateSelectedList, loading } = useSelectedSitesDataSource();

  const handleFormSubmit = useCallback(
    (formikRef: React.MutableRefObject<FormikProps<{ name: string }>>) => {
      const formik = formikRef.current;
      formik.submitForm().then(() => {
        const values = formik.values;
        formik.validateForm(values).then((validationErrors) => {
          isEmpty(validationErrors) && handleCreateSelectedList(values.name);
        });
      });
    },
    [handleCreateSelectedList]
  );

  return (
    <div className="flex flex-col mt-2 ml-4 mr-5" data-testid="sidebar-save-selected-sites-list-wrapper">
      <Formik
        enableReinitialize
        validationSchema={saveSelectedSitesListValidationSchemaFn()}
        initialValues={{
          name: '',
        }}
        onSubmit={() => {}}
        innerRef={formikRef}
      >
        {(formikProps) => (
          <form
            className="overflow-x-hidden max-w-full mb-6"
            onSubmit={formikProps.handleSubmit}
            data-testid="sidebar-save-selected-sites-list-form"
          >
            <FormGenerator
              {...formikProps}
              fieldsConfiguration={[
                {
                  label: t`List Name`,
                  property: 'name',
                  type: FormFieldTypeFG.Input,
                  containerClasses: 'flex justify-between flex-wrap items-start flex-row',
                },
              ]}
              formDisabled={false}
              newEditableLook
              dataTestId="sidebar-save-selected-sites-list-form"
            />
          </form>
        )}
      </Formik>
      <Button
        className="self-end"
        onClick={() => handleFormSubmit(formikRef)}
        disabled={loading}
        loading={loading}
        data-testid="sidebar-save-selected-sites-list-save-button"
      >
        <Trans>Save</Trans>
      </Button>
    </div>
  );
};
